import styled from "@emotion/styled";
import {css} from "@emotion/react";

const Wrapper = styled.div`
  position: relative;
  width: fit-content;
  height: fit-content;
`;

const AssignmentLoading = styled.div<{isLoading: boolean}>`
  inset: -3px;
  position: absolute;

  ${(props) =>
    props.isLoading &&
    css`
      @property --border-angle {
        syntax: "<angle>";
        inherits: true;
        initial-value: 0turn;
      }

      --border-size: 10px;
      --border-angle: 0turn;
      --radius: 8px;
      border-radius: var(--radius);
      padding: var(--border-size);

      background-image: conic-gradient(from var(--border-angle), #213, #112 50%, #213),
        conic-gradient(from var(--border-angle), transparent 20%, #08f, #f03);
      background-size: calc(100% - (var(--border-size) * 2)) calc(100% - (var(--border-size) * 2)), cover;
      background-position: center center;
      background-repeat: no-repeat;

      background-clip: border-box, padding-box;

      animation: bg-spin 3s linear infinite;

      @keyframes bg-spin {
        to {
          --border-angle: 1turn;
        }
      }
    `}
`;

const AssignmentLoadingWrapper = ({isLoading, children}: {isLoading: boolean; children: React.ReactNode}) => {
  return (
    <Wrapper>
      <AssignmentLoading isLoading={isLoading}></AssignmentLoading>
      {children}
    </Wrapper>
  );
};
export default AssignmentLoadingWrapper;
